import * as React from 'react';
import GenericHoc from 'components/common/generic-hoc';
import { HocOptions } from 'components/common/generic-hoc.types';
import { StylesProps, ThemeType } from 'theme/jss-types';
import { formFields } from 'components/create-consignment/create-modal.constants';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import {
    Col,
    Form,
    Select,
} from 'antd';
import { commonStyleSheet } from 'library/common-styles';
// import Helper from 'library/Helper';

const styles = (theme: ThemeType) => ({
    formItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
        '& .ant-checkbox + span': {
            color: '#111111',
            fontSize: 14,
            fontWeight: 600,
        },
    },
    title: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '100%',
    },
    referenceTitle: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '100%',
        marginBottom: 4,
    },
    contentType: {
        ...commonStyleSheet(theme).flexRow,
        '& .ant-form-item': {
            marginBottom: 0,
        },
    },
});

interface IProps extends StylesProps<ReturnType<typeof styles>>, ReturnType<typeof mapStateToProps> {
    params: any;
}

const ItemUnitField = (props: IProps) => {
    const { t } = useTranslation();
    const {
        classes,
        params,
        consignmentConfig,
    } = props;
    const {
        ItemUnitType,
    } = formFields;
    const {
        itemUnits,
        getValidationRules,
        getIsRequiredValidation,
    } = params;

    const customFields: Record<any, any> = {};
    if (consignmentConfig?.single_consignment_creation_fields) {
        (consignmentConfig?.single_consignment_creation_fields || {}).forEach((field: Record<any, any>) => {
            customFields[field.id] = field;
        });
    }

    if (!consignmentConfig?.allow_multiple_piece_dimensions) {
        return <></>;
    }

    const { key } = params;

    return (
        <Col span={12}>
            <div className={classes.formItem}>
                <div className={classes.title}>
                    { t('item_unit_label') }
                    {getIsRequiredValidation(ItemUnitType.key, true) && '*'}
                </div>
                <Form.Item
                    name={key}
                    className={classes.contentType}
                    initialValue={ItemUnitType.defaultValue}
                    valuePropName={ItemUnitType.valuePropName}
                    rules={getValidationRules(ItemUnitType, true)}
                >
                    <Select
                        placeholder={t('item_unit_label')}
                        showSearch
                        allowClear
                        options={itemUnits}
                    />
                </Form.Item>
            </div>
        </Col>
    );
};

const mapStateToProps = (state: any) => {
    const { master } = state;
    const { config } = master;
    return {
        consignmentConfig: get(config, 'customer_portal_consignment_config', {}),
    };
};

const hocConfig: HocOptions = {
    connectRedux: {
        useRedux: true,
        mapStateToProps,
    },
    connectJss: {
        useJss: true,
        styleSheet: styles,
    },
};

export default GenericHoc(hocConfig)(ItemUnitField);
